// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1BLPs","buttons":"PendingPaymentAlert_buttons__2bFia"};